import { type SearchRequest } from '@searchkit/api';

import { getBettingSplitsSorting } from '~/search-domain/pipelines/betting-splits/query-config';
import { createQueryFactory } from '~/search-domain/pipelines/betting-splits/query-factory';
import { type SearchDomainContext } from '~/search-domain/types';
import { isFacetOnlyRequest, normalizeFacetFilters, resolveActiveSort, withRequestParams } from '~/search-domain/utils';

export function buildBettingSplitsQuery(context: SearchDomainContext, searchRequest: SearchRequest) {
  if (isFacetOnlyRequest(searchRequest)) {
    return searchRequest;
  }

  const params = searchRequest.request?.params ?? {};
  const facetFilters = normalizeFacetFilters(params.facetFilters);

  const mappedSearchRequest = withRequestParams(searchRequest, {
    facetFilters,
    hitsPerPage: params.hitsPerPage ?? 10,
    page: params.page ?? 0,
  });

  const sorting = getBettingSplitsSorting(context);
  const activeSort = resolveActiveSort(
    mappedSearchRequest.indexName,
    mappedSearchRequest.request.indexName,
    sorting.options,
  );

  if (!activeSort) {
    throw new Error('Default sort not found');
  }

  return createQueryFactory({ activeSort, context, searchRequest: mappedSearchRequest });
}
